/**
 * launchCore — SSO-aware redirect to core.studox.eu
 *
 * If the user is currently logged in, this generates a short-lived SSO nonce
 * on the backend and redirects to core.studox.eu?sso=<nonce> so the Core hub
 * auto-logs them in without re-entering credentials.
 *
 * If the user is NOT logged in (or the request fails), they are redirected to
 * core.studox.eu without SSO (they can log in manually from there).
 */

import { useAuthStore } from "@/store/authStore";

const CORE_URL     = import.meta.env.VITE_CORE_URL    || "https://core.studox.eu";
const BACKEND_URL  = (import.meta.env.VITE_API_URL || "").replace("/api", "") || "http://localhost:4000";

export async function launchCore() {
  const { token, isAuthenticated } = useAuthStore.getState();

  if (!isAuthenticated || !token) {
    window.location.href = CORE_URL;
    return;
  }

  try {
    const res = await fetch(`${BACKEND_URL}/api/auth/sso-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({}),
    });

    if (!res.ok) throw new Error("sso-token failed");
    const { token: nonce } = await res.json();
    window.location.href = `${CORE_URL}?sso=${encodeURIComponent(nonce)}`;
  } catch {
    // Fallback: redirect without SSO
    window.location.href = CORE_URL;
  }
}
